module.exports = __webpack_public_path__ + "assets/images/b1_import_export_share.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images/b1_import_export_share.png
// module id = 971
// module chunks = 0